var r = function(a) {
  var t = a.label;
  return {
    "data-qm": "track-ucl",
    "data-qm-label": "UCL-" + t
  };
};
export {
  r as g
};
